import { Injectable } from '@angular/core';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogs = new Map<string, DialogComponent>();

  register(key: string, component: DialogComponent): void {
    this.dialogs.set(key, component);
  }

  unregister(key: string): void {
    this.dialogs.delete(key);
  }

  open(key: string, event?: any | undefined): void {
    this.dialogs.get(key)?._openDialog(event);
  }

  close(key: string, event?: any | undefined): void {
    this.dialogs.get(key)?._closeDialog(event);
  }
}
